import React from 'react';
import classnames from 'classnames';
import s from './index.less';
import { AbstractTooltipProps } from 'antd/es/tooltip';

export interface ActionProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  bottomTitle?: string;
  tooltipConfig?: AbstractTooltipProps;
  order?: number;
}
const ActionBtn: React.FC<ActionProps> = ({
  children,
  className,
  onClick,
  bottomTitle,
  order = 1,
}) => {
  return (
    <div
      className={classnames(className, isPad ? s.actionBtnPad : s.actionBtn)}
      onClick={onClick}
      style={{ order }}
    >
      <div className={classnames('btn-wrap', s.btnWrap)}>{children}</div>
      <div className={s.bottomTitle}>{bottomTitle}</div>
    </div>
  );
};
export default ActionBtn;
